import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

const links = [
  { href: "/#tjanster", label: "Tjänster" },
  { href: "/#omoss", label: "Om oss" },
  { href: "/artiklar", label: "Vanliga frågor" },
  { href: "/#kontakt", label: "Kontakt" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <nav className="sticky top-0 z-40 backdrop-blur-md bg-paper/80 border-b border-border/60">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="size-8 rounded-full bg-oak flex items-center justify-center">
            <span className="size-3 rounded-full bg-paper" />
          </span>
          <span className="font-display text-xl font-medium tracking-tight">Adminlaget</span>
        </Link>
        <div className="hidden md:flex items-center gap-9 text-sm font-medium text-ink-muted">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="hover:text-ink transition-colors">{l.label}</a>
          ))}
        </div>
        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/en/start-a-non-profit-association-in-sweden"
            hrefLang="en"
            className="text-sm font-medium text-ink-muted hover:text-ink transition-colors"
          >
            In English
          </Link>
          <a
            href="/#kontakt"
            className="bg-ink text-paper px-5 py-2.5 rounded-full text-sm font-medium hover:bg-ink-muted transition-colors"
          >
            Boka samtal
          </a>
        </div>
        <button
          aria-label="Meny"
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="size-5" /> : <Menu className="size-5" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-border/60 bg-paper px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-base font-medium">
              {l.label}
            </a>
          ))}
          <Link
            to="/en/start-a-non-profit-association-in-sweden"
            hrefLang="en"
            onClick={() => setOpen(false)}
            className="text-base font-medium"
          >
            In English
          </Link>
          <a href="/#kontakt" onClick={() => setOpen(false)} className="bg-ink text-paper px-5 py-3 rounded-full text-sm font-medium text-center">
            Boka samtal
          </a>
        </div>
      )}
    </nav>
  );
};